// IIFE - Immediately Invoked Function Expression
(function($, window, document) {

    // The $ is now locally scoped 

    // Listen for the jQuery ready event on the document
    $(function() {

        // The DOM is ready!

    });

    gsap.registerPlugin(ScrollTrigger);

    const counter = document.querySelectorAll('.count');
    if (counter) {
      counter.forEach(el => {
        const end = parseFloat(el.dataset.end) || 0;
        const proxy = { val: 0 };

        gsap.to(proxy, {
          val: end,
          duration: 2,
          ease: "power2.out",
          onUpdate: () => {
            el.textContent = Math.round(proxy.val).toLocaleString('pt-BR');
          },
          scrollTrigger: {
            trigger: el,
            start: "top 90%",   // quando o elemento chegar a 80% da viewport
            /*toggleActions: "play none none none", */
            toggleActions: "play none none reverse",
            //once: true          // roda só uma vez
          }
        });
      });     
    }


    const typingEl = document.querySelectorAll(".-typing");
    if (typingEl.length > 0) {
      gsap.utils.toArray(".-typing").forEach((text) => {
        //let text = document.querySelector(".-typing");
        let content = text.textContent;
        text.textContent = ""; // clear first
        gsap.to(text, {
          duration: 2.5,
          text: content,  // Requires TextPlugin
          ease: "none"
        });
      });
    }
    // Fade-in sections on scroll
    gsap.utils.toArray(".-fade-in").forEach((secfade) => {
      gsap.from(secfade, {
        opacity: 0,
        y: 100,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: secfade,
          start: "top 80%",
          toggleActions: "play none none reverse"
        }
      });
    });

    gsap.utils.toArray(".-animate-in").forEach((sec) => {
      /*gsap.to(sec, {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "none",
        //ease: "power2.out",
        scrollTrigger: {
          trigger: sec,
          start: "top 80%",
          toggleActions: "play none none reverse"
        }
      });*/
      gsap.from(sec, {
        opacity: 0,
        y: 100,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: sec,
          start: "top 80%",
          toggleActions: "play none none "
        }
      });
    });
    
    //Menu trigger
    var menuTrigger = document.getElementsByClassName("menu-trigger-btn"),
        menu = document.getElementById("main-nav");
    
    var toggleMenu = function() {
    	   //console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("menu-active");
    };

    for (var i = 0; i < menuTrigger.length; i++) {
        menuTrigger[i].addEventListener('click', toggleMenu, false);
    }

    //Search trigger
    var searchTrigger = document.getElementsByClassName("search-trigger-btn");
    
    var toggleSearch = function() {
         //console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("search-active");
    };

    for (var i = 0; i < searchTrigger.length; i++) {
        searchTrigger[i].addEventListener('click', toggleSearch, false);
    }

    //modal trigger
    var modalTrigger = document.getElementsByClassName("modal-trigger-btn");
    
    var toggleModal = function() {
        event.preventDefault();
        const modal = this.dataset.modal;
        if (modal) {
          document.getElementById(modal).classList.add('-modal-active');
        }
         //console.log('main nav offcanvas called')
        //menu.classList.toggle("offcanvas-nav-active");
        document.body.classList.toggle("modal-active");
    };

    for (var i = 0; i < modalTrigger.length; i++) {
        modalTrigger[i].addEventListener('click', toggleModal, false);
    }

    //modal close
    var modalClose = document.getElementsByClassName("modal-close-btn");
    
    var closeModal = function() {
        event.preventDefault();
        const modals = document.querySelectorAll('.-modal');
        modals.forEach(element => {
          element.classList.remove('-modal-active');
        });
        const formModals = document.querySelectorAll('.-modal-form');
        formModals.forEach(element => {
          element.classList.remove('-active');
        });
        document.body.classList.remove("modal-active");
    };

    for (var i = 0; i < modalClose.length; i++) {
        modalClose[i].addEventListener('click', closeModal, false);
    }     
    
    

    function redirect(goto){
        /*var conf = confirm("Are you sure you want to go elswhere?");
        if (conf && goto != '') {
            window.location = goto;
        }*/
        window.location = goto;
    }
   
    /*Anchor scroll*/
    const anchors = document.querySelectorAll(".scroll-anchor");
     
    for (const anchor of anchors) {
      anchor.addEventListener("click", clickHandler);
    }
     
    function clickHandler(e) {
      e.preventDefault();
      const header = document.querySelector("header").offsetHeight;
      const href = this.getAttribute("href"); 
      const offsetTop = document.querySelector(href).offsetTop;
     
      scroll({
        //top: offsetTop-header,
        top: offsetTop,
        behavior: "smooth"
      });
    }

    /*Anchor scroll nav*/
    const anchorsNav = document.querySelectorAll(".scroller > a");
     
    for (const anchorNav of anchorsNav) {
      anchorNav.addEventListener("click", clickHandlerNav);
    }
     
    function clickHandlerNav(e) {
      e.preventDefault();
      let header = document.querySelector("header").offsetHeight;
      let href = this.getAttribute("href"); 
      let split = href.split('#');
      let anchor = '#'+split[1];
      let offsetTop = document.querySelector(anchor).offsetTop;
      if (document.querySelector("header").classList.contains('-sticky')) {
        
      }else{
        header = header-20;
      }
      
      document.body.classList.remove("menu-active");
      
     
      scroll({
        top: offsetTop-header,
        /*top: offsetTop,*/
        behavior: "smooth"
      });
    } 


    /*Accordion*/
    $('[data-accordion]').click(function(e) {
        e.preventDefault();
        var parent = $(this).closest('.-accordion');
        /*var elParent = $(this).closest('.-accordion-item');*/

        //parent.find('.-accordion-item').removeClass('-active');

        if ( $(this).closest('.-accordion-item').hasClass('-active') ) {
            parent.find('.-accordion-item').removeClass('-active');
            $(this).closest('.-accordion-item').removeClass('-active');
        }else{
            parent.find('.-accordion-item').removeClass('-active');
            $(this).closest('.-accordion-item').addClass('-active');
        }
        
    });         
      

    /*Dropdown mobile*/
    $('.dropdown-toggle-hover').click(function(){
      
      if ($(window).width() < 1025) {
        event.preventDefault();
        var ddl = $(this).closest('.dropdown');
        ddl.toggleClass('open');
      }else{
        return;
      }
    });

    /*Tiny slider gallery*/
    const tnsSliderGallery = document.querySelectorAll('.-gallery-tns');
    tnsSliderGallery.forEach(sliderGallery => {
      const tnsSliderGallery = tns({
          container: sliderGallery,
          items: 1,
          nav: false,
          controls: true,
          autoplayButtonOutput: false,
          autoplay: false,
          autoplayTimeout: 4000,
          gutter: 0,
          loop: false,
          mouseDrag: false,
          controlsText: ['<span class="-prev"><iconify-icon icon="lucide:arrow-left"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="lucide:arrow-right"></iconify-icon></span>'],
          controlsPosition: "bottom",
      });
    }); 










    /*Tiny slider brands*/
    const tnsSliderBrands = document.querySelectorAll('.-resources-tns');
    tnsSliderBrands.forEach(sliderBrands => {
      const tnsSliderBrands = tns({
          container: sliderBrands,
          items: 3,
          nav: false,
          controls: false,
          autoplayButtonOutput: false,
          autoplayHoverPause: true,
          autoplay: true,
          autoplayTimeout: 2000,
          gutter: 30,
          loop: true,
          mouseDrag: true,
          controlsPosition: "bottom",
          controlsText: ['<span class="-prev"><iconify-icon icon="lucide:arrow-left"></iconify-icon></span>', '<span class="-next"><iconify-icon icon="lucide:arrow-right"></iconify-icon></span>'],
          responsive: { 
              1366: {
                items: 3,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              768: {
                items: 3,
                /*items: 2,
                nav: true,
                controls: false,*/
              },
              320: {
                /*loop: false,
                swipeAngle: false,
                items: 1.4,
                gutter: 24,*/
                items: 1,
                //autoplay: true,
                //gutter: 0
                /*loop: true,
                */
                /*gutter: 0,*/
              }, 
          }           
      });
    });     

    

    /*Tiny slider sponsor*/
    const tnsSingle = document.querySelector('.-single-tns');
    if (tnsSingle) {
      const tnsSlider = tns({
        container: tnsSingle,
        autoheight: false,
        items: 1,
        /*mouseDrag: true,*/
        autoplayButtonOutput: false,
        autoplay: false,
        loop: true,
        swipeAngle: false,
        navContainer: '.-single-tns-thumbs',
        navAsThumbnails: true,
        controlsText: ['<span class="-prev"><span class="iconify" data-icon="iconoir:arrow-left"></span></span>', '<span class="-next"><span class="iconify" data-icon="iconoir:arrow-right"></span></span>'],
  
        /*responsive: {     
          320: {
          },
          768: {
          },
          900: {
          }
        }*/


      });
      //tnsSlider.updateSliderHeight(); 
      var customizedFunction = function (info, eventName) {
        //tnsSlider.updateSliderHeight();
        //console.log(info);
        var indexCurrent = info.displayIndex;
        console.log(indexCurrent);
        var nextHeight = info.slideItems[indexCurrent].childNodes[1].clientHeight;
        /*console.log(nextHeight)*/
        info.container.offsetParent.childNodes[2].setAttribute('style', 'height:'+ nextHeight + 'px;');
      }
      tnsSlider.events.on('transitionEnd', customizedFunction);
      /*tnsSlider.events.on('indexChanged', customizedFunction);*/
    
    }
    const tnsSingleThumbs = document.querySelector('.-single-tns-thumbs');
    if (tnsSingleThumbs) {
      const tnsSlider = tns({
        container: tnsSingleThumbs,
        items: 6,
        mouseDrag: true,
        nav: false,
        controls: false,
        autoplayButtonOutput: false,
        gutter: 10,
        autoplay: false,
        controlsPosition: "bottom",
        loop: true,
        autoHeight: true,
  
        /*responsive: {     
          320: {
          },
          768: {
          },
          900: {
          }
        }*/

      });   
    
    }


                 

     /*GDPR*/
    document.addEventListener('DOMContentLoaded', function() {
      var cookiebar = document.querySelector('.cookiebar');
      if (cookiebar) { 
          var closecookiebar = document.querySelector('.hide-cookiebar-target');
          var acceptcookie = document.querySelector('.accept-cookies');
          var refusecookie = document.querySelector('.refuse-cookies');
          var cookie = readCookie('wh_cookie_lgpd_consent');/*Name of cookie*/
          //console.log(cookie);

          if (cookie == "true") {
              cookiebar.style.display = "none";
          }else if (cookie == "false") {
              cookiebar.style.display = "none";
          }else{
              cookiebar.classList.add("no-cookie-yet");
          }

          acceptcookie.addEventListener('click', function(e) {
              if(cookie != "true") {
                cookiebar.style.display = "none";
                createCookie('wh_cookie_lgpd_consent', "true", 7);
              } 
              e.preventDefault();
          });

          if (refusecookie) {
            refusecookie.addEventListener('click', function(e) {
                if(cookie != "true") {
                  cookiebar.style.display = "none";
                  createCookie('wh_cookie_lgpd_consent', "false", 7);
                }
                e.preventDefault();
            });  
          }
          
          if (closecookiebar) {
            closecookiebar.addEventListener('click', function(e) {
                cookiebar.style.display = "none";
                /*if(cookie != "true") {
                  createCookie('wh_cookie_lgpd_consent', "true", 1);
                } */
                e.preventDefault();
            });
          }

      }

      function createCookie(name, value, days) {
          if(days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            var expires = "; expires=" + date.toGMTString();
          } else var expires = "";
          document.cookie = name + "=" + value + expires + "; path=/"
      }

      function readCookie(name) {
          var nameEQ = name + "=";
          var ca = document.cookie.split(';');
          for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
           
          }
          return null;
      }

      function eraseCookie(name) {
          createCookie(name, "", -1);
      }

    });             

    var header = document.querySelectorAll(".dynamic-header");
    if (!header.length) { return; }
    var headerHeight = header[0].offsetHeight;
    window.onscroll = function() {
      //console.log(window.innerWidth)
        var scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
        var vh1o3 = (window.innerWidth/3);
        var vh1o2 = (window.innerWidth/2);
        var vhMin = 100;
        var vhMinWA = 200;
        /*if (scrollPosition > headerHeight && window.innerWidth > 992) {*/
        /*if (scrollPosition > headerHeight) {*/
        if (scrollPosition > vhMin) {
                header[0].classList.add('-sticky');
                
        }else{
                header[0].classList.remove('-sticky');
                
        }

        if (scrollPosition > vhMinWA) {
                
                document.body.classList.add("-has-sticky");
        }else{
                
                document.body.classList.remove("-has-sticky");
        }
    }; 

   

}(window.jQuery, window, document));